import React from 'react';
import { Box, Text, Flex, useColorMode } from '@chakra-ui/react';
import ThemePhoto from './ThemePhoto';
import './About.css';

const About: React.FC = () => {
  const { colorMode } = useColorMode();
  
  return (
    <Box
      id="about"
      as="section"
      className="about-container"
      bg={colorMode === 'dark' ? 'gray.800' : '#f8f8f8'}
    >
      {/* Desktop: text vlevo, fotka přes celou pravou polovinu (jako kontakt).
          Mobil: fotka nad textem – pořadí otáčí About.css. */}
      <Flex className="about-content">
        <Box className="about-text-section">
          <Box className="about-text reveal">
            <Text
              className="about-intro"
              color={colorMode === 'dark' ? 'white' : 'black'}
            >
              Něco málo o mně
            </Text>
            <Text
              className="about-description"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.700'}
            >
              Jmenuji se Eva Kodytková a jsem holka z Orlických hor, která miluje svou rodinu, přírodu a focení.
            </Text>
            <Text
              className="about-description"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.700'}
            >
              Moje cesta začala před pár lety, kdy jsem si s mužem pořídila první zrcadlovku na občasné focení. Láska k fotografii ve mně vzplála natolik, že jsem se tomuto řemeslu chtěla věnovat víc a víc.
            </Text>
            <Text
              className="about-description"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.700'}
            >
              Ráda zachycuji neopakovatelné momenty z Vašich životů, snažím se o autentičnost a také o to, aby focení se mnou pro Vás bylo co nejvíce přirozené a bavilo Vás stejně tak, jako mě.
            </Text>
            <Text
              className="about-description"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.700'}
            >
              Pokud máte zájem o jakékoliv focení, není nic jednoduššího než mi napsat.
            </Text>
            <Text
              className="about-description"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.700'}
            >
              Těším se na všechna naše setkání!
            </Text>
            <Text
              className="about-signature"
              color={colorMode === 'dark' ? 'white' : 'black'}
            >
              Ev*
            </Text>
          </Box>
        </Box>

        <Box className="about-image-section reveal">
          {/* Mobil: rámeček 260–380 px (About.css); na telefonu uvádíme jen
              266 px, aby náhled (800 px) stačil i na hustotě 3× a iPhone
              nestahoval velkou verzi. Desktop: pravá polovina okna na celou
              výšku – vždy velká verze (1200 px); náhled by na monitoru se
              škálováním 125 % i na tabletu na výšku byl měkký. Stejně jako
              vánoční fotka v ChristmasBooking.tsx. */}
          <ThemePhoto
            base="/photos/evicka"
            alt="Eva Kodytková"
            sizes="(max-width: 480px) 266px, (max-width: 768px) 380px, 1200px"
            widths={{ thumb: 800, full: 1200 }}
            className="about-image"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default About;
